let auth = null;

const AUTH_STORAGE_KEY = 'auth';

export const setUserDetails = () => {
    const authDetails = localStorage.getItem(AUTH_STORAGE_KEY) || sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (!authDetails) {
        auth = null;
        return;
    }
    try {
        auth = JSON.parse(authDetails);
    } catch (error) {
        // Corrupt storage shouldn't crash app init; getters already treat null auth as signed out.
        console.error("Failed to parse stored auth details:", error);
        auth = null;
    }
}

export const getUserDetails = () => {
    if (!auth) {
        setUserDetails();
    }
    return auth?.User;
}

export const getMarvinToken = () => {
    if (!auth) {
        setUserDetails();
    }
    return auth?.Tokens?.Token;
}

export const getRegionID = () => {
    if (!auth) {
        setUserDetails();
    }
    return auth?.Tenant?.RegionId;
}

export const getTenantName = () => {
    if (!auth) {
        setUserDetails();
    }
    return auth?.Tenant?.DisplayName;
}